module.exports = __webpack_public_path__ + "img/eye-crossed.c7d0ab52.svg";